import LeaderBoard from 'pages/LeaderBoard/LeaderBoard'
import StudentDashboard from 'pages/StudentDashboard'
import PrincipalDashboard from 'pages/PrincipalDashboard/dashboard/index'
import DashboardHome from 'pages/DashboardHome/index'
import SubjectMain from 'pages/DashboardHome/subject-main'
import StudentListMain from 'pages/DashboardHome/studentlist-main'

// import subjectDetail from "pages/PrincipalDashboard/dashboard/components/subject-detail";
// import masterSubjectDetail from "pages/MasterDashboard/dashboard/components/subject-detail";
import studentList from 'pages/PrincipalDashboard/student-list/index'
import masterStudentList from 'pages/MasterDashboard/student-list/index'
import studentDetail from 'pages/ParentDashboard/dashboard/index'
import selectSchool from 'pages/MasterDashboard/select-school/index'
import masterSchoolDashboard from 'pages/MasterDashboard/dashboard/index'
import TeacherDashboard from 'pages/TeacherDashboard/index'
import React from 'react'
import { Redirect } from 'react-router-dom'

// auth
import LoginPadhao from '../pages/Login'
import LoginCommon from '../pages/Login/login-common'
import PrincipalLogin from '../pages/PrincipalDashboard/login'
import Exam from 'pages/Exam/Exam'
import Login from '../pages/Onboarding/OtpLogin/OtpLogin'
import OtpLogin from 'pages/Onboarding/OtpLogin/OtpLogin'
// lazy load all the views
const Home = React.lazy(() => import('../pages/Home/index'))
const Reports = React.lazy(() => import('../pages/Reports'))
const ReportDetail = React.lazy(() => import('../pages/DetailReport'))
const Assessments = React.lazy(() => import('../pages/Assessments'))
const LiveClass = React.lazy(() => import('../pages/LiveClass'))
const LiveClasses = React.lazy(() => import('../pages/LiveClasses'))
const Chat = React.lazy(() => import('../pages/Chat'))
const Drive = React.lazy(() => import('../pages/Drive'))
const Doubts = React.lazy(() => import('../pages/Doubts'))
const CreateQuiz = React.lazy(() => import('../pages/CreateQuiz'))
const Scholarship = React.lazy(() => import('../pages/Scholarship'))
const QuizDetail = React.lazy(() =>
  import('../pages/CreateQuiz/components/QuizDetail'),
)
const QuizListing = React.lazy(() =>
  import('../pages/CreateQuiz/components/QuizListing'),
)
const AssessmentSec = React.lazy(() => import('../pages/AssessmentSec'))
const BoardCastClass = React.lazy(() => import('../pages/BroadCastClass'))
/* const Dashboard = React.lazy(() => import("../pages/dashboard/index"));
const StarterPage = React.lazy(() => import("../pages/StarterPage/index")); */
const ClassRoomsHome = React.lazy(() => import('../pages/ClassRooms'))
const Concept = React.lazy(() => import('../pages/pwa'))
const Profile = React.lazy(() => import('../pages/Profile'))
const Calendar = React.lazy(() => import('../pages/Calendar'))
const SelectSubject = React.lazy(() =>
  import('../pages/LearningFlow/SelectSubject/SelectSubject'),
)
const SelectChapter = React.lazy(() =>
  import('../pages/LearningFlow/SelectChapter/SelectChapter'),
)
const Quizzes = React.lazy(() => import('../pages/Quizzes'))

const QuizPlay = React.lazy(() =>
  import('../pages/Quizzes/components/Quiz/index'),
)
const SelectQuizSubject = React.lazy(() =>
  import('../pages/Quizzes/components/SelectQuizSubject/SelectQuizSubject'),
)
const SelectTestSubject = React.lazy(() =>
  import('../pages/Quizzes/components/SelectQuizSubject/SelectTestSubject'),
)
const SelectChallengeSubject = React.lazy(() =>
  import(
    '../pages/Quizzes/components/SelectQuizSubject/SelectChallengeSubject'
  ),
)
const LatexTesting = React.lazy(() =>
  import('../pages/Quizzes/components/SelectQuizSubject/LatexTesting'),
)
const LatexNewComponent = React.lazy(() =>
  import('../pages/Quizzes/components/SelectQuizSubject/LatexNewComponent'),
)
const AssessmentPlay = React.lazy(() =>
  import('../pages/Quizzes/components/Assessment/index'),
)
const ChallengePlay = React.lazy(() =>
  import('../pages/Quizzes/components/Challenge/index'),
)
const CompetativeExamPlay = React.lazy(() =>
  import('../pages/Quizzes/components/CompetativeExams/index'),
)
const ShowChallengeQuestion = React.lazy(() =>
  import(
    '../pages/Quizzes/components/Challenge/components/ShowChallengeQuestion'
  ),
)
const QuizCreatingGame = React.lazy(() =>
  import('../pages/Quizzes/components/Challenge/components/QuizCreatingGame'),
)
const WaitingLobby = React.lazy(() =>
  import('../pages/Quizzes/components/Challenge/components/WaitingLobby'),
)
const Island = React.lazy(() =>
  import('../pages/LearningFlow/ShowContent/Island'),
)
const TopicContent = React.lazy(() =>
  import('../pages/LearningFlow/ShowContent/TopicContent'),
)
const ReviseContent = React.lazy(() =>
  import('../pages/LearningFlow/ShowContent/ReviseContent'),
)
const TreasureContent = React.lazy(() =>
  import('../pages/LearningFlow/ShowContent/TreasureContent'),
)

const Plans = React.lazy(() => import('../pages/Plans/index'))
// const TopicContent = React.lazy(() =>
//   import("../pages/LearningFlow/ShowContent/TopicContent")
// );
// const DisplayBookmark = React.lazy(() =>
//   import("../pages/Bookmark/DisplayBookmark")
// );
const Bookmark = React.lazy(() => import('../pages/Bookmark/index'))
// const ShowBookmark = React.lazy(() =>
//   import("../pages/Profile/ShowBookMark")
// );
const BookmarkList = React.lazy(() => import('../pages/Bookmark/BookmarkList'))

const CommonRail = React.lazy(() =>
  import('../pages/LearningFlow/ShowContent/CommonRails'),
)

const paceLive = React.lazy(() => import('../pages/paceLIveClasses/paceLive'))
const JoinLiveClass = React.lazy(() =>
  import('../pages/paceLIveClasses/JoinLiveClass'),
)

const NoContentFound = React.lazy(() =>
  import('../pages/LearningFlow/NoContentFound/NoContentFound'),
)

const AskDoubts = React.lazy(() => import('../pages/AskDoubts'))


const SuperFifty = React.lazy(() =>
  import('../pages/SuperFifty'),
)
const SuperFifty2 = React.lazy(() =>
  import('../pages/SuperFifty/Superfifty19Nov'),
)
const HST = React.lazy(() => import('../pages/SuperFifty/hst'))

const SFSelect = React.lazy(() => import('pages/SuperFifty/sfSelect'))

const SFSelect2 = React.lazy(()=> import('pages/SuperFifty_1/sfSelect'))

/* import Logout from "../pages/Auth/Logout";
import ForgetPassword from "../pages/Auth/ForgetPassword";
import Register from "../pages/Auth/Register";
import LockScreen from "../pages/Auth/LockScreen"; */

// declare all routes
const authProtectedRoutes = [
  // { path: "/dashboard", component: Home, meta: { auth: true } },
  { path: '/pages-starter', component: Home, meta: { auth: true } },
  { path: '/home/:roomId', component: Home, meta: { auth: true } },
  { path: '/home', component: Home, meta: { auth: true } },
  { path: '/room/:roomId', component: Home, meta: { auth: true } },
  { path: '/room', component: Home, meta: { auth: true } },
  { path: '/meeting/:roomId', component: Home, meta: { auth: true } },
  { path: '/reports', component: Reports, meta: { auth: true } },
  { path: '/create-quiz', component: CreateQuiz, meta: { auth: true } },
  { path: '/quiz-detail', component: QuizDetail, meta: { auth: true } },
  { path: '/quiz-listing', component: QuizListing, meta: { auth: true } },
  { path: '/assessment-quiz', component: AssessmentSec, meta: { auth: true } },
  { path: '/report-details', component: ReportDetail, meta: { auth: true } },
  { path: '/live-class', component: QuizListing, meta: { auth: true } },
  { path: '/chat', component: Chat, meta: { auth: true } },
  { path: '/assessments', component: Assessments, meta: { auth: true } },
  { path: '/drive', component: Drive, meta: { auth: true } },
  { path: '/class-rooms/', component: ClassRoomsHome, meta: { auth: true } },
  { path: '/class-rooms/*', component: ClassRoomsHome, meta: { auth: true } },
  { path: '/doubts', component: Doubts, meta: { auth: true } },
  { path: '/doubts/*', component: Doubts, meta: { auth: true } },
  { path: '/broadcast', component: BoardCastClass, meta: { auth: true } },
  { path: '/scholarship', component: Scholarship, meta: { auth: true } },
  {
    path: '/concepts',
    component: SelectSubject,
    temp: 'false',
    meta: { auth: true, temp: false },
  },
  {
    path: '/:subjectslug/chapters',
    component: SelectChapter,
    meta: { auth: true, name: 'subject' },
  },
  {
    path: '/:subjectslug/:chapterslug/topics',
    component: Island,
    meta: { auth: true, name: 'chapter' },
  },
  {
    path: '/:subjectslug/:chapterslug/:topicslug/concept',
    component: TopicContent,
    meta: { auth: true, name: 'topic' },
  },
  {
    path: '/revise/:subjectslug/:chapterslug',
    component: ReviseContent,
    meta: { auth: true },
  },
  {
    path: '/treasurecontent/:subjectslug/:chapterslug',
    component: TreasureContent,
    meta: { auth: true },
  },
  {
    path: '/liveclass/:school_chain_id/:schoolid/:roomId/:serviceName',
    component: paceLive,
    meta: { auth: true },
  },
  {
    path: '/liveclass/:school_chain_id/:schoolid/:roomId',
    component: paceLive,
    meta: { auth: true },
  },
  {
    path: '/pace/liveclass/:schoolid/:roomId',
    component: JoinLiveClass,
    meta: { auth: true },
  },
  { path: '/code', component: Concept, meta: { auth: true } },
  { path: '/leaderboard', component: LeaderBoard, meta: { auth: true } },
  { path: '/profile', component: Profile, meta: { auth: true } },
  { path: '/calendar', component: Calendar, meta: { auth: true } },
  { path: '/live-classes', component: LiveClasses, meta: { auth: true } },
  { path: '/exams/:firstname/:lastname/:type/:schoolName', component: Exam, meta: { auth: true } },
  // { path: '/exams/:type', component: Exam, meta: { auth: true } },
  // { path: '/exams/:firstname/:lastname/:type/:email', component: Exam, meta: { auth: true } },
  { path: '/exams/:firstname/:lastname/:type', component: Exam, meta: { auth: true } },

  { path: '/exams', component: Exam, meta: { auth: true } },

  // -------- Dashboard Routes ---------/
  { path: '/dashboard', component: DashboardHome, meta: { auth: true } },
  { path: '/subject-detail', component: SubjectMain, meta: { auth: true } },
  { path: '/student-list', component: StudentListMain, meta: { auth: true } },

  // { path: "/student-dashboard", component: StudentDashboard ,meta: { auth: true }},
  {
    path: '/principal-dashboard',
    component: PrincipalDashboard,
    meta: { auth: true },
  },
  // { path: "/master-dashboard", component: MasterDashboard ,meta: { auth: true }},
  // { path: "/student-list", component: studentList ,meta: { auth: true }},
  // {
  //   path: "/master-student-list",
  //   component: masterStudentList,
  //   meta: { auth: true },
  // },
  { path: '/student-detail', component: studentDetail, meta: { auth: true } },
  // { path: "/subject-detail", component: subjectDetail ,meta: { auth: true }},
  // { path: "/master-subject-detail", component: masterSubjectDetail ,meta: { auth: true }},
  { path: '/select-school', component: selectSchool, meta: { auth: true } },
  {
    path: '/master-school-dashboard',
    component: masterSchoolDashboard,
    meta: { auth: true },
  },
  { path: '/ask-doubts', component: AskDoubts, meta: { auth: true } },
  /*------------------Assessment routes start-----------------------*/
  {
    path: '/assessment/practicequiz/challenge/:subject',
    component: ChallengePlay,
    meta: { auth: true },
  }, //done
  {
    path: '/assessment/practicequiz/challenge',
    component: SelectChallengeSubject,
    meta: { auth: true },
  }, //done
  {
    path: '/assessment/practicequiz/:subject',
    component: QuizPlay,
    meta: { auth: true },
  }, //done
  {
    path: '/assessment/practicequiz',
    component: SelectQuizSubject,
    meta: { auth: true },
  }, //done
  {
    path: '/assessment/practicetest/:subject/:assessmentId',
    component: AssessmentPlay,
    meta: { auth: true },
  }, //done
  {
    path: '/assessment/practicetest/:subject/',
    component: AssessmentPlay,
    meta: { auth: true },
  }, //done
  {
    path: '/assessment/practicetest/',
    component: SelectTestSubject,
    meta: { auth: true },
  }, //done
  {
    path: '/assessment/quiz/:assessmentId',
    component: QuizPlay,
    meta: { auth: true },
  }, //done
  {
    path: '/assessment/WaitingLobby/:roomcode',
    component: WaitingLobby,
    meta: { auth: true },
  }, //done
  {
    path: '/assessment/challenge/question',
    component: ShowChallengeQuestion,
    meta: { auth: true },
  }, //done
  {
    path: '/assessment/challenge/:assessmentId',
    component: ChallengePlay,
    meta: { auth: true },
  }, //done
  {
    path: '/assessment/test/:assessmentId',
    component: AssessmentPlay,
    meta: { auth: true },
  },
  {
    path: '/assessment/competativeexam/:assessmentId',
    component: CompetativeExamPlay,
    meta: { auth: true },
  },
  {
    path: '/assessment/showPlayers/:roomcode',
    component: QuizCreatingGame,
    meta: { auth: true },
  },
  {
    path: '/assessment/testing',
    component: LatexTesting,
    meta: { auth: true },
  },
  { path: '/assessment', component: Quizzes, meta: { auth: true } }, //done

  /*------------------Assessment routes end-----------------------*/

  /*------------------No Content routes start-----------------------*/
  { path: '/nocontent', component: NoContentFound, meta: { auth: true } },
  /*------------------No Content routes end-----------------------*/

  /*------------------Bookmarks routes start-----------------------*/

  {
    path: '/:bookmarked/:subjectslug/:chapterslug/:topicslug/concept',
    component: TopicContent,
    meta: { auth: true, name: 'topic' },
  },
  // {
  //   path: "/displayBookmark/:subjectslug/:chapterslug/:topicslug",
  //   component: DisplayBookmark,
  // },
  // { path: "/showBookmark", component: ShowBookmark },
  {
    path: '/bookmarkList/:subject',
    component: BookmarkList,
    meta: { auth: true },
  },
  { path: '/bookmarks', component: Bookmark, meta: { auth: true } },
  /*------------------Bookmarks routes end-----------------------*/

  { path: '/displayLink', component: CommonRail, meta: { public: true } },
  { path: '/plans', component: Plans, meta: { auth: true } },
  {
    path: '/latex',
    exact: true,
    component: LatexNewComponent,
    meta: { auth: true },
  },

  /*----------------- super50 -----------------*/
  
  {
    path: '/pacesuper50',
    exact: true,
    component: SFSelect,
    meta: { auth: true },
  },
  // {
  //   path: '/super50-delhi',
  //   exact: true,
  //   component: SFSelect,
  //   meta: { auth: true },
  // },
  
  {
    path: '/super50-select-test',
    exact: true,
    component: HST,
    meta: { auth: true },
  },

  {
    path: '/',
    exact: true,
    component: () => <Redirect to="/concepts" />,
    meta: { auth: true },
  },
]

const publicRoutes = [
  { path: "/login-otp", component: Login, exact: true, meta: {guest: true }},
  {
    path: '/login/:usertype',
    exact: true,
    component: LoginPadhao,
    meta: { guest: true },
  },
  {
    path: '/login',
    exact: true,
    component: LoginCommon,
    meta: { guest: true },
  },

  // {
  //   path: '/practicetest',
  //   exact: true,
  //   component: SFSelect,
  //   meta: { auth: true }, 
  // },
// https://digitalpace.stepapp.in/practicetest
  {
    path: '/super50-test',
    exact: true,
    component: SFSelect,
    meta: { auth: true }, 
  },
  // {
  //   path: '/super50-alt',
  //   exact: true,
  //   component: SFSelect,
  //   meta: { auth: true }, 
  // },

  {
    path: '/super50',
    exact: true,
    component: SFSelect,
    meta: { auth: true }, 
  },

  {
    path: '/kv-super50-1-test',
    exact: true,
    component: SFSelect,
    meta: { auth: true },
  },

  {
    path: '/kv-super50-1',
    exact: true,
    component: SFSelect,
    meta: { auth: true },
  },
  {
    path: '/kv-super50',
    exact: true,
    component: SFSelect,
    meta: { auth: true },
  },

  {
    path: '/super50indus',
    exact: true,
    component: SFSelect,
    meta: { auth: true }, 
  },
  /* { path: "/forget-password", component: ForgetPassword },
  { path: "/register", component: Register },
  { path: "/lock-screen", component: LockScreen},
  { path: "/logout", component: Logout }, */
]

const routes = [...authProtectedRoutes, ...publicRoutes]

export { authProtectedRoutes, publicRoutes, routes }
